import { DomainInitPayload, LoginSMS } from '@sxm-de/dev-kits/web-sdk/types';
import {
    getAuthTokenCookieValue,
    getAuthTokenParsed,
    logErrorFromMicroservicesSdk,
} from '@sxm-de/dev-kits/web-sdk/utils';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface LoginSMSFnPayload {}

export type LoginSMSFn = (payload: LoginSMSFnPayload) => Promise<LoginSMS>;

export function initLoginSMSFn({
    dependencies,
}: DomainInitPayload): LoginSMSFn {
    const { microservicesSdk } = dependencies;
    return async (payload: LoginSMSFnPayload) => {
        const authToken = JSON.parse(getAuthTokenCookieValue() || '');
        if (!authToken) {
            throw new Error('SYSTEM');
        }
        const authTokenParsed = getAuthTokenParsed(authToken);
        const identityGrant = authTokenParsed?.identityGrant?.grant;
        if (!identityGrant) {
            throw new Error('SYSTEM');
        }
        const requestPayload = { identityGrant, ...payload };

        try {
            return await microservicesSdk.domains.authenticate.login(
                requestPayload,
            );
        } catch (error: any) {
            if (error?.errorCode === 'ACCOUNT_IN_DIFFERENT_COUNTRY') {
                throw new Error('ACCOUNT_IN_DIFFERENT_COUNTRY');
            } else if (error?.errorCode === 'SXIR_ACCOUNT_TYPE_NOT_SUPPORTED') {
                throw new Error('ACCOUNT_TYPE_NOT_SUPPORTED');
            } else if (
                error?.errorCode === 'PROSPECT_ACCOUNT_TYPE_NOT_SUPPORTED'
            ) {
                throw new Error('PROSPECT_ACCOUNT_TYPE_NOT_SUPPORTED');
            } else if (error?.errorCode === 'CUSTOMER_TYPE_NOT_SUPPORTED') {
                throw new Error('CUSTOMER_TYPE_NOT_SUPPORTED');
            } else {
                logErrorFromMicroservicesSdk(error, dependencies);
                throw new Error('SYSTEM');
            }
        }
    };
}
